import React from 'react';
/** DISPLAY NAME: &lt;SortableStatic.Row&gt; */
var StaticRow = function (_a) {
    var children = _a.children;
    return React.createElement(React.Fragment, null, children);
};
export default StaticRow;
